import { render } from "./OnboardingCard.vue?vue&type=template&id=a3622676&scoped=true"
import script from "./OnboardingCard.vue?vue&type=script&lang=js"
export * from "./OnboardingCard.vue?vue&type=script&lang=js"

import "./OnboardingCard.vue?vue&type=style&index=0&id=a3622676&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3622676"]])

export default __exports__